import { useState } from 'react';

interface Car {
  id: number;
  name: string;
  type: string;
  image: string;
  price: number;
  passengers: number;
  luggage: number;
  features: string[];
  description: string;
}

const CarsGallery = () => {
  const cars: Car[] = [
    {
      id: 1,
      name: 'تويوتا هايس',
      type: 'فان',
      image: 'https://public.readdy.ai/ai/img_res/776e428025c3b2c0b708b44b6e928620.jpg',
      price: 400,
      passengers: 14,
      luggage: 8,
      features: ['مساحة واسعة للركاب', 'مقاعد مريحة ومبطنة', 'تكييف قوي وفعال', 'مساحة تخزين كبيرة'],
      description: 'فان فسيح ومريح يتسع لعدد كبير من الركاب مع راحة فائقة',
    },
    {
      id: 2,
      name: 'هيونداي ستاريا',
      type: 'فان عائلي',
      image: 'https://readdy.ai/api/search-image?query=elegant%20white%20Hyundai%20Staria%20luxury%20van%20front%20angle%20view%20on%20clean%20white%20background%20with%20professional%20automotive%20lighting%2C%20premium%20family%20van%20photography%2C%20modern%20sophisticated%20design%2C%20sleek%20exterior%2C%20executive%20transport%20vehicle&width=800&height=600&seq=staria-001&orientation=landscape',
      price: 450,
      passengers: 11,
      luggage: 6,
      features: ['تصميم حديث وأنيق', 'مقاعد جلدية فاخرة', 'نظام ترفيهي متطور', 'إضاءة LED داخلية'],
      description: 'فان عائلي عصري يجمع بين الراحة والفخامة والتصميم المتطور',
    },
    {
      id: 3,
      name: 'تويوتا كامري',
      type: 'سيدان',
      image: 'https://readdy.ai/api/search-image?query=sophisticated%20white%20Toyota%20Camry%20sedan%20front%20three%20quarter%20view%20on%20clean%20white%20background%20with%20elegant%20studio%20lighting%2C%20premium%20executive%20car%20photography%2C%20refined%20luxury%20sedan%2C%20polished%20finish%2C%20professional%20automotive%20shot&width=800&height=600&seq=camry-001&orientation=landscape',
      price: 350,
      passengers: 5,
      luggage: 4,
      features: ['مقاعد جلدية مريحة', 'نظام ملاحة متطور', 'تحكم مناخي ذكي', 'نظام أمان شامل'],
      description: 'سيدان أنيقة توفر قيادة مريحة وآمنة مع تقنيات حديثة',
    },
    {
      id: 4,
      name: 'فورد تورس',
      type: 'سيدان',
      image: 'https://readdy.ai/api/search-image?query=elegant%20white%20Ford%20Taurus%20luxury%20sedan%20front%20angle%20view%20on%20clean%20white%20background%20with%20professional%20studio%20lighting%2C%20premium%20executive%20car%20photography%2C%20sophisticated%20design%2C%20refined%20exterior%2C%20high-end%20automotive%20shot&width=800&height=600&seq=taurus-001&orientation=landscape',
      price: 380,
      passengers: 5,
      luggage: 4,
      features: ['محرك قوي وموفر', 'مقاعد مبردة ومدفأة', 'شاشة تحكم كبيرة', 'نظام صوتي عالي الجودة'],
      description: 'سيدان قوية وفاخرة تقدم أداء ممتاز وراحة استثنائية',
    },
    {
      id: 5,
      name: 'GMC يوكون',
      type: 'SUV',
      image: 'https://readdy.ai/api/search-image?query=powerful%20white%20GMC%20Yukon%20luxury%20SUV%20front%20three%20quarter%20view%20on%20clean%20white%20background%20with%20dramatic%20studio%20lighting%2C%20premium%20large%20SUV%20photography%2C%20commanding%20presence%2C%20sophisticated%20design%2C%20executive%20transport%20vehicle&width=800&height=600&seq=yukon-001&orientation=landscape',
      price: 550,
      passengers: 8,
      luggage: 6,
      features: ['مساحة فاخرة وواسعة', 'دفع رباعي متطور', 'تعليق هوائي', 'نظام ترفيهي شامل'],
      description: 'سيارة SUV فاخرة وقوية توفر أداء استثنائي وراحة قصوى للعائلات',
    },
    {
      id: 6,
      name: 'تويوتا كوستر',
      type: 'باص صغير',
      image: 'https://readdy.ai/api/search-image?query=white%20Toyota%20Coaster%20minibus%20front%20angle%20view%20on%20clean%20white%20background%20with%20professional%20lighting%2C%20premium%20passenger%20transport%20bus%20photography%2C%20executive%20shuttle%20vehicle%2C%20modern%20design%2C%20polished%20exterior%20finish&width=800&height=600&seq=coaster-001&orientation=landscape',
      price: 600,
      passengers: 25,
      luggage: 10,
      features: ['سعة كبيرة للركاب', 'مقاعد مريحة ومبطنة', 'تكييف مركزي قوي', 'مساحة تخزين واسعة'],
      description: 'باص صغير مثالي للمجموعات الكبيرة والرحلات الجماعية',
    },
  ];

  const handleCarClick = (carId: number) => {
    window.REACT_APP_NAVIGATE(`/car-details/${carId}`);
  };

  return (
    <section id="cars-gallery" className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h3 className="text-luxury-black font-almarai font-bold text-4xl lg:text-5xl mb-4">
            معرض <span className="text-gold">السيارات</span>
          </h3>
          <div className="w-20 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-luxury-gray font-cairo text-lg max-w-2xl mx-auto">
            اختر من بين مجموعتنا الفاخرة من السيارات المتميزة
          </p>
        </div>

        {/* Cars Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {cars.map((car) => (
            <div
              key={car.id}
              onClick={() => handleCarClick(car.id)}
              className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              {/* Car Image with Logo Overlay */}
              <div className="relative w-full h-64 bg-gray-100 overflow-hidden">
                <img
                  src={car.image}
                  alt={car.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                {/* Logo Overlay */}
                <div className="absolute top-4 right-4">
                  <img 
                    src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/5e6df9ce5b9899c6272cf68673fdbb8b.png"
                    alt="فخامة الرفاهية"
                    className="w-24 h-auto object-contain drop-shadow-lg"
                  />
                </div>
                {/* Price Badge */}
                <div className="absolute bottom-4 left-4 bg-luxury-black/90 backdrop-blur-sm px-5 py-2 rounded-full">
                  <span className="font-cairo font-bold text-gold text-lg">{car.price} ريال</span>
                </div>
              </div>

              {/* Car Info */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-almarai font-bold text-2xl text-luxury-black">{car.name}</h4>
                  <span className="bg-gold/20 text-gold font-cairo font-semibold text-sm px-3 py-1 rounded-full">
                    {car.type}
                  </span>
                </div>

                <p className="font-cairo text-luxury-gray text-sm mb-4 line-clamp-2">
                  {car.description}
                </p>

                {/* Quick Info */}
                <div className="flex items-center gap-4 mb-4 text-luxury-gray">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-gold"></i>
                    <span className="font-cairo text-sm">{car.passengers} راكب</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-luggage-cart-line text-gold"></i>
                    <span className="font-cairo text-sm">{car.luggage} حقائب</span>
                  </div>
                </div>

                <button className="w-full bg-luxury-black hover:bg-gold text-white hover:text-luxury-black font-cairo font-semibold py-3 rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap">
                  عرض التفاصيل
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CarsGallery;
